import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  CartItem,
  CartService,
  transformToCartItem,
} from 'src/app/services/cart.service';
import { GoogleSheetService } from 'src/app/services/google-sheet.service';
import { SidenavService } from 'src/app/services/sidenav/sidenav.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { formatProductUrl } from 'src/app/config/constants';
@Component({
  selector: 'app-producto-detalle',
  templateUrl: './producto-detalle.component.html',
  styleUrls: ['./producto-detalle.component.scss'],
})
export class ProductoDetalleComponent implements OnInit {
  id: any;
  producto: any = {};
  presentacionSeleccionada: any = null;
  totalItemsCart: any = 0;
  descripcionExpandida = false;
  isMobile: boolean = false;
  productImages: any[] = [];

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    navSpeed: 700,
    navText: ['', ''],
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      740: {
        items: 1
      },
      940: {
        items: 1
      }
    },
    nav: false
  };

  constructor(
    private route: ActivatedRoute,
    private googleSheet: GoogleSheetService,
    private sidenavService: SidenavService,
    private cartService: CartService,
    private breakpointObserver: BreakpointObserver,
    private router: Router,
  ) { }

  ngAfterViewInit() {
    const elmnt = document.getElementById('top'); 
    elmnt.scrollIntoView({behavior: 'smooth'});
  }

  ngOnInit(): void {
    
    this.breakpointObserver
      .observe([Breakpoints.Handset])
      .subscribe((result) => {
        this.isMobile = result.matches;
      });

    var queryParamPresentacion =
      this.route.snapshot.queryParamMap.get('presentacion');
    if (queryParamPresentacion != null) {
      this.presentacionSeleccionada =
        this.route.snapshot.queryParamMap.get('presentacion');
    }

    this.totalItemsCart = this.cartService.getTotalItems();
    this.cartService.cartItems$.subscribe((items) => {
      this.totalItemsCart = this.cartService.getTotalItems();
    });
    this.route.paramMap.subscribe((params) => {
      this.id = params.get('id');
      console.log(this.id);
      this.producto = this.googleSheet.getProductoById(this.id);

      // Crear el array de imágenes para el carrusel
      this.productImages = [
        { id: '1', src: 'assets/productos-img/' + formatProductUrl(this.producto.url) }
      ];

      console.log(this.producto);
    });
  }

  selectPresentacion(presentacion) {
    if (this.presentacionSeleccionada == presentacion) {
      this.presentacionSeleccionada = null;
      return;
    }
    this.presentacionSeleccionada = presentacion;
  }
  openSidenav() {
    this.sidenavService.open();
  }

  closeSidenav() {
    this.sidenavService.close();
  }

  toggleSidenav() {
    this.sidenavService.toggle();
  }

  addProductToCart(product: any): void {
    const cartItem: CartItem = transformToCartItem(
      product,
      this.presentacionSeleccionada,
      1
    );
    this.cartService.addToCart(cartItem);
    this.presentacionSeleccionada = null;

    if (!this.isMobile) {
      this.sidenavService.toggle();
    }
    this.router.navigate(['/']);
  }

  getProductImageUrl(url: string): string {
    return `url('${url.trim()}')`;
  }
}
